import React, { useEffect, useRef, useState } from "react";
import {FormControl, IconButton, FormControlLabel, Radio, RadioGroup,} from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useForm, Controller } from "react-hook-form";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css"; // Import Quill styles
import "../../../App.css";
import { useNavigate, useParams } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Box, Typography, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import { fetchEntityById, postResource } from "../../../apis/apiService";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import apiSlice, { useFetchGetallManagersQuery, useFetchTimesheetNamesQuery,} from "../../../slice/logdetailSlice";
import { toast } from "react-toastify";
import Loader, { BtnLoader } from "../../common/Loader";
// import { useSelector } from "react-redux";
import { DateRange } from "react-date-range";
import { addWeeks, subWeeks, startOfWeek, endOfWeek } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Popover, List, ListItem, ListItemText } from "@mui/material";
import { ArrowBack, ArrowForward, CalendarToday } from "@mui/icons-material";
import Slider from "react-slick";
import { extractTextFromHTML } from "../../../utils/textUtils";
import { PiBagFill } from "react-icons/pi";
import TimesheetActivity, { TimerActivityStream } from "./TimesheetActivity";

const predefinedRanges = [
  { label: "Today", startDate: new Date(), endDate: new Date() },
  {
    label: "Week",
    startDate: startOfWeek(new Date()),
    endDate: endOfWeek(new Date()),
  },
  {
    label: "Month",
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    endDate: new Date(),
  },
  {
    label: "All",
  },
];

export const CustomCalendar = () => {
  const id = localStorage.getItem("project_id");
  const [open, setOpen] = useState(false);
  const [selectionRange, setSelectionRange] = useState({
    startDate: startOfWeek(new Date()),
    endDate: endOfWeek(new Date()),
    key: "selection",
  });

  const [projectSpan, setProjectSpan] = useState("week");
  const from_date = format(selectionRange.startDate, "yyyy-MM-dd");
  const to_date = format(selectionRange.endDate, "yyyy-MM-dd");


  const handleSelect = (ranges) => {
    setSelectionRange({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: "selection",
    });
  };

  const handleClick = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handlePrevWeek = () => {
    setSelectionRange((prev) => ({
      startDate: subWeeks(prev.startDate, 1),
      endDate: subWeeks(prev.endDate, 1),
      key: "selection",
    }));
    setProjectSpan("week");
  };

  const handleNextWeek = () => {
    setSelectionRange((prev) => ({
      startDate: addWeeks(prev.startDate, 1),
      endDate: addWeeks(prev.endDate, 1),
      key: "selection",
    }));
    setProjectSpan("week");
  };

  const handlePredefinedSelect = (range) => {
    setSelectionRange({
      startDate: range.startDate,
      endDate: range.endDate,
      key: "selection",
    });
    setProjectSpan(range.label.toLowerCase());
  };

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <IconButton onClick={handlePrevWeek}>
        <ArrowBack />
      </IconButton>

      <Typography
        variant="body1"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        {format(selectionRange.startDate, "MMM d, yyyy")} -{" "}
        {format(selectionRange.endDate, "MMM d, yyyy")}
      </Typography>

      <IconButton onClick={handleClick}>
        <CalendarToday />
      </IconButton>
      <IconButton onClick={handleNextWeek}>
        <ArrowForward />
      </IconButton>

      <Popover
        open={open}
        onClose={handleClose}
        anchorReference="none"
        PaperProps={{
          style: {
            width: "60%",
            maxWidth: "700px",
            padding: "10px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
          },
        }}
      >
        <Box
          sx={{
            width: "200px",
            borderRight: "1px solid #ddd",
            padding: "10px",
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: 1 }}>
            Select Range
          </Typography>
          <List>
            {predefinedRanges.map((range, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handlePredefinedSelect(range)}
              >
                <ListItemText primary={range.label} />
              </ListItem>
            ))}
          </List>
        </Box>

        <Box sx={{ flexGrow: 1, padding: "10px" }}>
          <DateRange
            ranges={[selectionRange]}
            onChange={handleSelect}
            moveRangeOnFirstSelection={false}
            rangeColors={["rgba(18, 183, 159, 1)"]}
            months={1}
            direction="horizontal"
            showDateDisplay={false}
          />

          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            mt={2}
          >
            <button className="cancel_btn" onClick={handleClose}>
              Cancel
            </button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export const SubTimesheetTabs = ({ login_user_id, TimesheetDetail }) => {

  return (
    <div className=" ">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <button
            className=" active text-rgba-gray R_btn"
            id="timelog-tab"
            data-bs-toggle="tab"
            data-bs-target="#timelog"
            type="button"
            role="tab"
            aria-controls="timelog"
            aria-selected="true"
          >
            Timer Activity Stream
          </button>
        </li>
        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Comments-tab"
            data-bs-toggle="tab"
            data-bs-target="#Comments"
            type="button"
            role="tab"
            aria-controls="Comments"
            aria-selected="true"
          >
            Timelog Activity Stream
          </button>
        </li>
      </ul>
      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="timelog"
          role="tabpanel"
          aria-labelledby="timelog-tab"
        >
          <TimesheetActivity timesheet_details={TimesheetDetail} />
        </div>
        <div
          className="tab-pane fade"
          id="Comments"
          role="tabpanel"
          aria-labelledby="Comments-tab"
        >
          <TimerActivityStream />
        </div>
      </div>
    </div>
  );
};
// const login_user = useSelector((state) => state.selectOptions?.loginUserName);
// //console.log()("login_user in pproject:", login_user);
// const { role: login_user_role } = login_user;
// //console.log()("login_user role in project:", login_user_role);
const AutocompleteComponent = ({ options, value, onChange }) => (
  <div style={{ width: 100 }}>
    <Autocomplete
      options={options}
      value={value}
      // disabled={login_user_role === "CLIENT"}
      disableClearable
      onChange={(event, val) => onChange(val)}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          sx={{
            "& .MuiInputBase-root": {
              height: "36px", // Adjust the height here
              width: "70px",
            },
            "& input": {
              padding: "8px", // Adjust padding for the input text
              width: "70px",
            },
          }}
        />
      )}
    />
  </div>
);

const TimesheetDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  //console.log()("timesheet detail id :", id);
  const [showDetail, setShowDetail] = useState([]);
  const [headanchorEl, setHeadAnchorEl] = useState(null);
  const { handleSubmit, control, watch } = useForm();
  const [loading, setLoading] = useState([]);
  const [totalHours, setTotalHours] = useState(null);
  const [notes, setNotes] = useState("");
  const [billingType, setBillingType] = useState("");
  const [timelogList, setTimelogList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [updatedNames, setUpdatedNames] = useState({});
  const project_id = localStorage.getItem("project_id");
  const timesheet_type_watch = watch("timesheet_type");
  const [approvalStatus, setApprovalStatus] = useState("");
  const [selectedTimesheetType, setSelectedTimesheetType] = useState("");
  // console.log("timesheet_type_watch :", timesheet_type_watch);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // console.log("login_user in pproject:", project_id);
  const { id: login_user_id } = login_user;
  //console.log()("login_user role in project:", login_user_role);
  const [selectionRange, setSelectionRange] = useState({
    startDate: startOfWeek(new Date()),
    endDate: endOfWeek(new Date()),
    key: "selection",
  });
  const [projectSpan, setProjectSpan] = useState("week");
  const from_date = format(selectionRange.startDate, "yyyy-MM-dd");
  const to_date = format(selectionRange.endDate, "yyyy-MM-dd");

  const { data: manager_list, refetch: manager_list_refresh } =
    useFetchGetallManagersQuery();
  const navigate = useNavigate();
  const handleMenuOpen = (event) => {
    setHeadAnchorEl(event.currentTarget);
  };
  const [newDate, setNewDate] = useState(null);
  const convertTo12HourFormat = (time) => {
    if (!time) return ""; // Handle null/undefined values

    const [hour, minute] = time.split(":").map(Number);
    const amPm = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12; // Convert 0 to 12 for AM
    return `${formattedHour}:${minute.toString().padStart(2, "0")} ${amPm}`;
  };
  // timesheet show
  // const { data: all_timelogs, refetch: all_timelogs_refetch } =
  //   useFetchTimesheetNamesQuery(project_id);
  const { data: all_timelogs, refetch: all_timelogs_refetch } =
    useFetchTimesheetNamesQuery(
      { project_id, user_id: login_user_id },
      { skip: !project_id }
    );

  const formatTime = (hour, minute, amPm) => {
    let formattedHour = parseInt(hour, 10);
    if (amPm === "PM" && formattedHour !== 12) {
      formattedHour += 12;
    } else if (amPm === "AM" && formattedHour === 12) {
      formattedHour = 0;
    }
    return `${formattedHour.toString().padStart(2, "0")}:${minute}`;
  };

  const handleMenuClose = () => {
    setHeadAnchorEl(null);
  };

  useEffect(() => {
    manager_list_refresh();
  }, []);

  const sliderRef = useRef(null);
  useEffect(() => {
    all_timelogs_refetch();
  }, [id, project_id, all_timelogs]);
  const settings = {
    dots: false,
    infinite: all_timelogs?.length > 1, // Only infinite if >1 item
    slidesToShow: all_timelogs?.length > 1 ? 4 : 1, // Don't exceed available items
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
    // beforeChange: (currentSlide, nextSlide) =>
    //console.log()("Before change", currentSlide, nextSlide),
    // afterChange: (currentSlide) => //console.log()("After change", currentSlide),
  };

  const handleBoxClick = (timeLogId) => {
    navigate(`/projects/projectDetail/${project_id}/timesheet/TimeSheetDetail/${timeLogId}`);
  };

  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  // const onSubmit = (data) => {
  //   //console.log()(data);
  // };
  const handleTextChange = (value) => {
    setNotes(value);
    //console.log()(value);
  };

  const handleBillingChange = (e) => {
    const selectedValue = e.target.value;
    setBillingType(selectedValue);
    //console.log()(selectedValue);
  };

  const updateTimelogDatas = async (date = selectedDate) => {
    const dayjsDate = dayjs(date); // Ensure it's a proper dayjs object
    const formattedDate = dayjsDate.isValid()
      ? dayjsDate.format("YYYY-MM-DD")
      : null;

    //console.log()("New Selected Date:", formattedDate);  
    setSelectedDate(selectedDate);
    setNewDate(formattedDate); // Still update state for UI consistency

    if (showDailyLog && !totalHours) {
      toast.error('Please enter total hours in "Enter Hours".');
      return;
    }
    if (
      !showDailyLog &&
      (!selectedHour ||
        !selectedMinutes ||
        !secondSelectedHour ||
        !secondselectedMinutes)
    ) {
      toast.error('Please provide start and end time in "Daily Log".');
      return;
    }

    const convertTo24HourFormat = (hour, minutes, amPm) => {
      let hourInt = parseInt(hour, 10);
      if (amPm === "PM" && hourInt < 12) {
        hourInt += 12;
      } 
       if (amPm === "AM" && hourInt === 12) {
        hourInt = 0;
      }
      return `${hourInt.toString().padStart(2, "0")}:${minutes}`;
    };

    let postData;

    if (showDailyLog) {
      postData = {
        notes: notes,
        hours_in_text: totalHours,
      };

      if (formattedDate) {
        postData.log_date = formattedDate;
        //console.log()("selected_validate_date formatted date:", formattedDate);
      } 
      else if (dayjs(selectedDate).isValid()) {
        postData.log_date = dayjs(selectedDate).format("YYYY-MM-DD");
        //console.log()("selected_validate_date fallback date:", postData.log_date);
      } 
      else {
        //console.log()("Invalid date detected!");
        toast.error("Invalid date. Please select a valid date.");
        return;
      }
    } 
    else {
      const formattedStartTime = convertTo24HourFormat(
        selectedHour,
        selectedMinutes,
        selectedAmPm
      );
      const formattedEndTime = convertTo24HourFormat(
        secondSelectedHour,
        secondselectedMinutes,
        secondselectedAmPm
      );

      postData = {
        notes: notes,
        start_time: formattedStartTime,
        end_time: formattedEndTime,
      };

      if (formattedDate) {
        postData.log_date = formattedDate;
        //console.log()("selected_validate_date formatted date:", formattedDate);
      }
      else if (dayjs(selectedDate).isValid()) {
        postData.log_date = dayjs(selectedDate).format("YYYY-MM-DD");
        //console.log()("selected_validate_date fallback date:", postData.log_date);
      }
       else {
        //console.log()("Invalid date detected!");
        toast.error("Invalid date. Please select a valid date.");
        return;
      }
    }

    //console.log()("Post Data:", postData);

    try {
      const response = await postResource("timesheet", "update", id, postData);
      //console.log()("Timesheet update response:", response);
      toast.success(response.message);
      dispatch(apiSlice.util.invalidateTags(["Timesheet"]));
      showTimelogIds();
    } 
    catch (err) {
      console.error("Error in updating timesheet detail:", err);
      toast.error(err.message);
    } 
    finally {
      showTimelogIds();
    }
  };

  const updateTimesheetType = async (selectedType, previousType) => {
    // Normalize values (case-insensitive check)

    // console.log("aaaaaaaaaaa",selectedType,previousType);

    const oldType = (previousType || "").toUpperCase();
    const newType = (selectedType || "").toUpperCase();

    // console.log("Previous:", oldType, " → Selected:", newType);

    // 🚫 Skip API when switching to OT
    if (newType === "OT") {
      // console.log("Switched to OT — skipping API call");
      return;
    }

    // ✅ Only call API when switching from OT → REGULAR
    if (oldType === "OT" && newType === "REGULAR") {
      // console.log("Switched from OT → REGULAR — calling API...");
    } 
    else {
      // console.log("No API call needed for this transition");
      return;
    }

    const formattedDate = dayjs(selectedDate).isValid()
      ? dayjs(selectedDate).format("YYYY-MM-DD")
      : null;

    let postData;

    if (showDailyLog) {
      postData = {
        notes,
        hours_in_text: totalHours,
        log_date: formattedDate,
        timesheet_type: newType,
      };
    } 
    else {
      const convertTo24HourFormat = (hour, minutes, amPm) => {
        let hourInt = parseInt(hour, 10);
        if (amPm === "PM" && hourInt < 12) hourInt += 12;
        else if (amPm === "AM" && hourInt === 12) hourInt = 0;
        return `${hourInt.toString().padStart(2, "0")}:${minutes}`;
      };

      const formattedStartTime = convertTo24HourFormat(
        selectedHour,
        selectedMinutes,
        selectedAmPm
      );
      const formattedEndTime = convertTo24HourFormat(
        secondSelectedHour,
        secondselectedMinutes,
        secondselectedAmPm
      );

      postData = {
        notes,
        start_time: formattedStartTime,
        end_time: formattedEndTime,
        log_date: formattedDate,
        timesheet_type: newType,
      };
    }

    try {
      const response = await postResource("timesheet", "update", id, postData);
      toast.success(response.message);
      dispatch(apiSlice.util.invalidateTags(["Timesheet"]));
      showTimelogIds();
    } 
    catch (err) {
      console.error("Error updating timesheet type:", err);
      toast.error(err.message);
    } 
    finally {
      showTimelogIds();
    }
  };

  const updateReportedManager = async (managerId) => {
    if (!managerId) {
      toast.error("Please select a valid manager.");
      return;
    }

    const postData = {
      timesheet_type: "OT",
      reported_manager_id: managerId,
    };

    try {
      const response = await postResource("timesheet", "update", id, postData);
      toast.success(response.message || "Manager updated successfully");
      dispatch(apiSlice.util.invalidateTags(["Timesheet"]));
      showTimelogIds(); // ✅ refresh data after success
    } 
    catch (err) {
      console.error("Error updating manager:", err);
      toast.error(err.message || "Failed to update manager");
    }
  };

  // Attach updateTimelogDatas correctly

  useEffect(() => {
    if (selectedDate) {
      const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
      setNewDate(formattedDate);
    }
  }, [selectedDate]); // Ensures `newDate` updates *after* `selectedDate` has changed

  useEffect(() => {
    if (newDate) {
      //console.log()("new_date_format :", newDate);
    }
  }, [newDate]); // Ensures API call happens after `newDate` is set

  const [btnLoading, setBtnLoading] = useState(false);
  // Handle Add Button Click
  const handleAddClick = async () => {
    setBtnLoading(true);
    try {
      const formatTimesFormat = (hour, minute, amPm) => {
        if (!hour || !minute || !amPm) return null;
        const isPM = amPm === "PM";
        const formattedHour = isPM
          ? hour === "12"
            ? "12"
            : String(Number(hour) + 12).padStart(2, "0")
          : hour === "12"
            ? "00"
            : hour.padStart(2, "0");
        return `${formattedHour}:${minute}`;
      };
      const startTime = formatTimesFormat(
        selectedHour,
        selectedMinutes,
        selectedAmPm
      );
      const endTime = formatTimesFormat(
        secondSelectedHour,
        secondselectedMinutes,
        secondselectedAmPm
      );
      if (!showDailyLog) {
        // Check if start time and end time are equal
        if (startTime === endTime) {
          console.error("Start time or end time is missing or invalid.");
          toast.error("Start time and end time cannot be the same.");
          return;
        }
      }
      await updateTimelogDatas();
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      setBtnLoading(false);
    }
  };

  // useEffect(() => {
  //   // showTimelogIds();
  //   updateTimelogDatas();
  // }, [selectedDate, notes, totalHours]);
  const showTimelogIds = async () => {
    setLoading(true);
    try {
      const response = await fetchEntityById("timesheet/view", id);

      if (response?.data) {
        // console.log("Timesheet detail data:", response.data);
        setSelectedTimesheetType(response?.data?.timesheet_type);

        // Check if response.data is an array or object
        if (Array.isArray(response.data)) {
          // const data = response.data;
          setShowDetail(response.data);
          //console.log()("show detail :", showDetail);

          // console.log("show detail",response.data);
          if (showDetail[0]) {
            setApprovalStatus(showDetail[0].approval_status);
            setNotes(showDetail[0].notes || ""); // Set notes if available
            setBillingType(showDetail[0].billing_type || ""); // Set billing type
            setSelectedDate(dayjs(showDetail[0].log_date)); // Set date

            // Check if start_time and end_time are valid (not null)
            const isStartTimeValid = dayjs(showDetail[0].start_time).isValid();
            const isEndTimeValid = dayjs(showDetail[0].end_time).isValid();

            // Update showDailyLog based on the validity of start_time and end_time
            if (isStartTimeValid && isEndTimeValid) {
              setShowDailyLog(false); // If valid, do not show daily log input
            } else {
              setShowDailyLog(true); // If invalid, show daily log input
            }
          }
        } 
        else if (typeof response.data === "object") {
          setShowDetail([response.data]);
          setApprovalStatus(response.data.approval_status);
          setNotes(response.data.notes || ""); // Set notes if available
          setBillingType(response.data.billing_type || ""); // Set billing type
          setSelectedDate(dayjs(response.data.log_date)); // Set date

          // Check if start_time and end_time are valid (not null)
          const isStartTimeValid = dayjs(response.data.start_time).isValid();
          const isEndTimeValid = dayjs(response.data.end_time).isValid();

          // Update showDailyLog based on the validity of start_time and end_time
          if (isStartTimeValid && isEndTimeValid) {
            setShowDailyLog(false); // If valid, do not show daily log input
          } 
          else {
            setShowDailyLog(true); // If invalid, show daily log input
            setTotalHours(response.data.hours_in_text);
          }
        } 
        else {
          toast.warn("Unexpected data format:", response.data);
          setShowDetail([]); // Fallback to an empty array
        }
      } 
      else {
        toast.warn("Unexpected response format:", response);
        setShowDetail([]); // Fallback to an empty array
      }
    } 
    catch (err) {
      console.error("Error in fetching timesheet detail:", err);
      setShowDetail([]); // Ensure state is cleared on error
    } 
    finally {
      setLoading(false);
    }
  };

  // const { data, refetch, isLoading } =
  //   useFetchTimeSheetLogDetailsQuery(project_id);
  // const { data, isLoading, error, refetch } = useFetchTimeSheetLogDetailsQuery(
  //   {
  //     project_id,
  //     project_span: projectSpan,
  //     from_date,
  //     to_date,
  //   },
  //   {
  //     skip: !project_id || project_id === "undefined" || project_id === "null",
  //   }
  // );
  // //console.log()(" id data :", data);
  // useEffect(() => {
  //   if (data) {
  //     const subTaskData = data.map((item) => item.subtasks).flat();
  //     // console.info("==================", subTaskData);
  //     setTimelogList(subTaskData); // Update state only when `data` changes
  //   }
  // }, [data]); // Dependency array ensures this effect runs only when `data` changes
  useEffect(() => {
    if (id) {
      showTimelogIds();
    }
  }, [id]); // ✅ Now runs only when `id` is valid

  // const handleClose = () => {
  //   //console.log()("Updated Date in onClose:", selectedDate);
  //   updateTimelogDatas();
  // };
  const hourOptions = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );
  const [selectedHour, setSelectedHour] = useState(hourOptions[0]);
  const [secondSelectedHour, setSecondSelectedHour] = useState(hourOptions[0]);

  const minutesOptions = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  const [selectedMinutes, setSelectedMinutes] = useState(minutesOptions[0]);
  const [secondselectedMinutes, setSecondSelectedMinutes] = useState(
    minutesOptions[0]
  );

  const amPmOptions = ["AM", "PM"];
  const [selectedAmPm, setSelectedAmPm] = useState(amPmOptions[0]);
  const [secondselectedAmPm, setSecondSelectedAmPm] = useState(amPmOptions[0]);

  const [showDailyLog, setShowDailyLog] = useState(false);
  //console.log()("showDetail :", showDetail);
  const convertTo12HourAutoFormat = (time24) => {
    if (!time24) {
      return {
        hour: "12",
        minutes: "00",
        seconds: "00",
        amPm: "AM",
      };
    }

    const [hours, minutes, seconds] = time24.split(":");
    let hour = parseInt(hours, 10);
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // Adjust for midnight (0 hour)
    return {
      hour: hour.toString().padStart(2, "0"),
      minutes: minutes,
      seconds: seconds,
      amPm: amPm,
    };
  };

  useEffect(() => {
    if (showDetail.length > 0) {
      showDetail.forEach((val) => {
        // Process start time if available
        if (val.start_time) {
          const startTime = convertTo12HourAutoFormat(val.start_time);
          setSelectedHour(startTime.hour);
          setSelectedMinutes(startTime.minutes);
          setSelectedAmPm(startTime.amPm);
        }

        // Process end time if available
        if (val.end_time) {
          const endTime = convertTo12HourAutoFormat(val.end_time);
          setSecondSelectedHour(endTime.hour);
          setSecondSelectedMinutes(endTime.minutes);
          setSecondSelectedAmPm(endTime.amPm);
        }
        const hasStartEndTime = val.start_time && val.end_time;
        setShowDailyLog(!hasStartEndTime);
      });
    }
  }, [showDetail]);
  // console.log("show_details :", showDetail);

  const isDisabled =
    selectedTimesheetType === "OT" &&
    (approvalStatus === "REJECTED" || approvalStatus === "APPROVED");

  console.log("disabled date", isDisabled);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="container-fluid ">
          {showDetail?.map((list, index) => {
            return (
              <>
                <div
                  // className="row w-100 "
                  style={{ height: "100%", width: "100%" }}
                  className="bg-white p-3"
                  key={index}
                >
                  {/* Header */}
                  <div className="d-flex flex-wrap justify-content-between align-items-center border-bottom pb-2 mb-3">
                    <div className="d-flex text-rgba-gray align-items-center gap-2">
                      <button
                        className=" R_btn me-3"
                        onClick={() => window.history.back()}
                      >
                        <IoIosArrowBack className="text-rgba-gray" />
                      </button>
                      <div className="d-flex flex-column">
                        <div className="d-flex gap-3">
                          {list.project_title && (
                            <label className="text-capitalize">
                              <PiBagFill className=" lightText" />
                              {list.project_title}
                            </label>
                          )}
                        </div>
                        <div>
                          {list.project_title && (
                            <label className=" text-capitalize">
                              by {list.added_name} | {list.log_type}
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* 
                  <IconButton onClick={handleMenuOpen}>
                    <label className="text-dark">...</label>
                  </IconButton>
                  <Menu
                    anchorEl={headanchorEl}
                    open={Boolean(headanchorEl)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem>Edit</MenuItem>
                    <MenuItem>Delete</MenuItem>
                    <MenuItem>Clone</MenuItem>
                  </Menu> */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-9 col-md-8 bg-white p-3 rounded">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      {/* <form onSubmit={handleSubmit(onSubmit)}> */}
                      <div className="row g-3">
                        <div className="col-sm-6 col-md-4">
                          <label>Total Log Hours</label>
                          <p className="timelogHours">
                            {list.hours_in_text} hr{" "}
                          </p>
                        </div>
                        <div className="col-sm-6 col-md-4">
                          <label>Timesheet Log</label>
                          <p className="timelogDetailHeading text-uppercase ">
                            {convertTo12HourFormat(list.start_time)} -
                            {convertTo12HourFormat(list.end_time)}
                          </p>
                        </div>
                        <div className="col-sm-6 col-md-4">
                          <FormControl component="fieldset">
                            <label>Billing Type</label>
                             <RadioGroup
                              row
                              value={billingType}
                              sx={{
                                userSelect: "none",
                                cursor: "default", // cursor logic
                              }}
                              // onChange={handleBillingChange}
                              name="billingType"
                            >
                              <Tooltip title={`This task is set as ${billingType?.toUpperCase() === "NON-BILLABLE" ? "Non-Billable" : "Billable"}, so it cannot be modified.`} arrow>
                                <span>
                                  <FormControlLabel
                                // sx={{ userSelect: "none" }}
                                    sx={{
                                      cursor: "not-allowed !important",
                                      "& .MuiFormControlLabel-label": {
                                        cursor: "not-allowed !important",
                                      },
                                      "& .MuiRadio-root": {
                                        cursor: "not-allowed !important",
                                      },
                                    }}
                                    value="BILLABLE"
                                control={<Radio disabled={isDisabled} />}
                                    label="Billable"
                                  />
                                </span>
                              </Tooltip>

                              <Tooltip title={`This task is set as ${billingType?.toUpperCase() === "NON-BILLABLE" ? "Non-Billable" : "Billable"}, so it cannot be modified.`} arrow>
                                <span>
                                  <FormControlLabel
                                    sx={{
                                      cursor: "not-allowed !important",
                                      "& .MuiFormControlLabel-label": {
                                        cursor: "not-allowed !important",
                                      },
                                      "& .MuiRadio-root": {
                                        cursor: "not-allowed !important",
                                      },
                                    }}
                                    value="NON-BILLABLE"
                                control={<Radio disabled={isDisabled} />}
                                    label="Non-Billable"
                                  />
                                </span>
                              </Tooltip>
                            </RadioGroup>
                          </FormControl>
                        </div>

                        <div className="col-sm-6 col-md-8 ">
                          <div className="col-sm-6 col-md-12 d-flex flex-wrap align-items-center justify-content-between ">
                            <div className="col-sm-6 col-md-4">
                              <label> Date</label>
                              <div>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DatePicker
                                    value={selectedDate}
                                    format="DD/MM/YYYY"
                                    disableFuture
                                    onChange={updateTimelogDatas} // Ensure it passes `date` argument
                                    disabled={isDisabled}
                                    renderInput={(params) => (
                                      <input {...params} />
                                    )}
                                  />
                                </LocalizationProvider>
                              </div>
                            </div>

                            <div className="col-sm-6 col-md-4 col-12">
                              <label>User</label>
                              <p className="timelog-heading text-capitalize ">
                                {list.added_name}
                              </p>
                            </div>
                          </div>

                          <div className="col-sm-6 col-md-12 d-flex flex-wrap align-items-center justify-content-between mt-2">
                            <div className="col-md-6">
                              <label
                                htmlFor="timesheetType"
                                className="form-label"
                              >
                                Timesheet Type
                              </label>
                              <Controller
                                name="timesheet_type"
                                control={control}
                                rules={{ required: "Type field is required" }}
                                render={({ field, fieldState: { error } }) => (
                                  <div>
                                    <RadioGroup
                                      row
                                      value={selectedTimesheetType} // ✅ controlled by local state
                                      onChange={(e) => {
                                        if (isDisabled) return;
                                        const newType = e.target.value;
                                        field.onChange(newType);
                                        updateTimesheetType(
                                          newType,
                                          selectedTimesheetType
                                        ); // pass current + previous
                                        setSelectedTimesheetType(newType); // ✅ update local value after call
                                      }}
                                    >
                                      <FormControlLabel
                                        value="REGULAR"
                                        control={
                                          <Radio disabled={isDisabled} />
                                        }
                                        label="Regular"
                                      />
                                      <FormControlLabel
                                        value="OT"
                                        control={
                                          <Radio disabled={isDisabled} />
                                        }
                                        label="OT"
                                      />
                                    </RadioGroup>

                                    {error && (
                                      <p className="errorMsg">
                                        {error.message}
                                      </p>
                                    )}
                                  </div>
                                )}
                              />
                            </div>

                            {(list.reported_manager_id ||
                              selectedTimesheetType === "OT") && (
                                <div className="col-sm-6 col-md-4 col-12">
                                  <label
                                    htmlFor="reported_manager_id"
                                    className="form-label"
                                  >
                                    Manager
                                  </label>
                                  <div className="d-flex flex-column w-100">
                                    <FormControl fullWidth>
                                      <Controller
                                        name="reported_manager_id"
                                        control={control}
                                        rules={{
                                          required: "Manager field is required",
                                        }}
                                        render={({
                                          field: { onChange, value },
                                        }) => {
                                          // Determine selected manager based on either the form value or the list value
                                          const selectedManager =
                                            manager_list?.find(
                                              (manager) =>
                                                manager.user_id === value ||
                                                manager.user_id ===
                                                list.reported_manager_id
                                            ) || null;

                                          return (
                                            <Autocomplete
                                              id="reported_manager_id"
                                              disabled={isDisabled}
                                              options={
                                                Array.isArray(manager_list)
                                                  ? manager_list
                                                  : []
                                              }
                                              getOptionLabel={(option) =>
                                                option?.name || ""
                                              }
                                              isOptionEqualToValue={(
                                                option,
                                                val
                                              ) =>
                                                option.user_id === val?.user_id
                                              }
                                              value={selectedManager}
                                              onChange={(e, newValue) => {
                                                if (!isDisabled) {
                                                  // prevent change when disabled
                                                  onChange(
                                                    newValue?.user_id || null
                                                  );
                                                  updateReportedManager(
                                                    newValue?.user_id
                                                  );
                                                }
                                              }}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  placeholder="Select Manager"
                                                  fullWidth
                                                  disabled={isDisabled}
                                                />
                                              )}
                                            />
                                          );
                                        }}
                                      />
                                    </FormControl>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>

                        <div className="col-sm-6 col-md-4">
                          <label>Daily Log Hours</label>

                          <div
                            className="row"
                            style={{ opacity: isDisabled ? 0.6 : 1 }}
                          >
                            {showDailyLog && (
                              <div className="col-md-12">
                                <TextField
                                  defaultValue="0:00"
                                  placeholder="00:00"
                                  value={totalHours}
                                  variant="outlined"
                                  fullWidth
                                  disabled={isDisabled}
                                  onChange={(e) => {
                                    if (!isDisabled)
                                      setTotalHours(e.target.value);
                                  }}
                                  onBlur={() => {
                                    if (!isDisabled)
                                      updateTimelogDatas(selectedDate);
                                  }}
                                />
                              </div>
                            )}

                            {!showDailyLog && (
                              <div className="col-md-12 mt-1">
                                {/* First Row */}
                                <div className="d-flex gap-3 justify-content-start mb-3">
                                  <AutocompleteComponent
                                    options={hourOptions}
                                    value={selectedHour}
                                    disabled={isDisabled}
                                    onChange={(val) =>
                                      !isDisabled && setSelectedHour(val)
                                    }
                                    onBlur={
                                      !isDisabled
                                        ? updateTimelogDatas
                                        : undefined
                                    }
                                  />
                                  <AutocompleteComponent
                                    options={minutesOptions}
                                    value={selectedMinutes}
                                    disabled={isDisabled}
                                    onChange={(val) =>
                                      !isDisabled && setSelectedMinutes(val)
                                    }
                                    onBlur={
                                      !isDisabled
                                        ? updateTimelogDatas
                                        : undefined
                                    }
                                  />
                                  <AutocompleteComponent
                                    options={amPmOptions}
                                    value={selectedAmPm}
                                    disabled={isDisabled}
                                    onChange={(val) =>
                                      !isDisabled && setSelectedAmPm(val)
                                    }
                                    onBlur={
                                      !isDisabled
                                        ? updateTimelogDatas
                                        : undefined
                                    }
                                  />
                                </div>

                                {/* Second Row */}
                                <div className="d-flex gap-3 justify-content-start">
                                  <AutocompleteComponent
                                    options={hourOptions}
                                    value={secondSelectedHour}
                                    disabled={isDisabled}
                                    onChange={(val) =>
                                      !isDisabled && setSecondSelectedHour(val)
                                    }
                                    onBlur={
                                      !isDisabled
                                        ? updateTimelogDatas
                                        : undefined
                                    }
                                  />
                                  <AutocompleteComponent
                                    options={minutesOptions}
                                    value={secondselectedMinutes}
                                    disabled={isDisabled}
                                    onChange={(val) =>
                                      !isDisabled &&
                                      setSecondSelectedMinutes(val)
                                    }
                                    onBlur={
                                      !isDisabled
                                        ? updateTimelogDatas
                                        : undefined
                                    }
                                  />
                                  <AutocompleteComponent
                                    options={amPmOptions}
                                    value={secondselectedAmPm}
                                    disabled={isDisabled}
                                    onChange={(val) =>
                                      !isDisabled && setSecondSelectedAmPm(val)
                                    }
                                    onBlur={
                                      !isDisabled
                                        ? updateTimelogDatas
                                        : undefined
                                    }
                                  />
                                </div>
                              </div>
                            )}
                          </div>

                          {/* Toggle "enter hours" / "set start & end time" */}
                          <div
                            className="col-md-4"
                            style={{
                              cursor: isDisabled ? "default" : "pointer",
                            }}
                          >
                            <p
                              className="text-rgbr-blue mt-2 text-nowrap cursor-pointer"
                              onClick={() => setShowDailyLog(!showDailyLog)}
                            >
                              {" "}
                              {!showDailyLog
                                ? "enter hours"
                                : "set start & end time"}{" "}
                            </p>
                          </div>

                          {!showDailyLog && (
                            <div className="d-flex justify-content-left mt-3">
                              <button
                                type="submit"
                                className="me-3 add_btn"
                                disabled={isDisabled || btnLoading}
                                onClick={
                                  !isDisabled ? handleAddClick : undefined
                                }
                              >
                                {btnLoading ? <BtnLoader /> : "Add"}
                              </button>

                              <button
                                type="button"
                                className="cancel_btn"
                                disabled={isDisabled || btnLoading}
                                onClick={() =>
                                  !isDisabled && setShowDailyLog(!showDailyLog)
                                }
                              >
                                Cancel
                              </button>
                            </div>
                          )}
                        </div>

                        <div className=" col-12">
                          <div className=" d-flex justify-content-end">
                            <button
                              className=" AddButton btn"
                              onClick={updateTimelogDatas}
                            >
                              Update Notes
                            </button>
                          </div>
                        </div>
                        
                        <div className="col-12">
                          <label>Notes</label>

                          <ReactQuill
                            placeholder="Add notes here..."
                            value={notes}
                            readOnly={isDisabled}
                            onChange={handleTextChange}
                            // onBlur={updateTimelogDatas}
                            modules={{
                              toolbar: isDisabled
                                ? false
                                : [
                                  // ⬅️ hides toolbar if disabled
                                  [{ header: [1, 2, false] }],
                                  ["bold", "italic", "underline"],
                                  [{ list: "ordered" }, { list: "bullet" }],
                                  ["link"],
                                ],
                            }}
                          />
                        </div>
                      </div>
                      {/* </form> */}
                    </LocalizationProvider>

                    <div className=" mt-3">
                      <SubTimesheetTabs TimesheetDetail={showDetail} />
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4 bg-white border rounded">
                    <div
                      style={{ height: "100%", width: "100%" }}
                      className="bg-white"
                    >
                      <div className="d-flex p-2 align-items-end justify-content-between">
                        <h4 className="mb-1">All Timelogs</h4>
                        <div className="arrows gap-2 d-flex">
                          <button
                            className="slick-prev"
                            onClick={handleNextClick}
                          >
                            <FaChevronUp />
                          </button>
                          <button
                            className="slick-next"
                            onClick={handlePrevClick}
                          >
                            <FaChevronDown />
                          </button>
                        </div>
                      </div>

                      <Slider {...settings} ref={sliderRef}>
                        {all_timelogs?.map((timelog, index) => (
                          <div
                            key={index}
                            className={`border rounded p-3 mb-2 box ${timelog?.time_logs_id === list.time_logs_id
                                ? "active bg-danger "
                                : ""
                              }`}
                            onClick={() => handleBoxClick(timelog.time_logs_id)}
                          >
                            <div className="d-flex align-items-center pb-3">
                              <div
                                className="pe-2 fw-bold truncated-text"
                                title={timelog.notes}
                              >
                                {timelog.notes.length > 20
                                  ? extractTextFromHTML(
                                    timelog.notes
                                  ).substring(0, 20) + "..."
                                  : extractTextFromHTML(timelog.notes)}
                              </div>
                              {/* <div className="taskHighlight"></div> */}
                            </div>
                            
                            <div className="d-flex align-items-center">
                              <label className="text-rgba-gray pe-2 d-flex align-items-center">
                                Owner
                              </label>
                              <label className="   text-nowrap ">
                                {timelog.owner_name}
                              </label>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      )}
    </>
  );
};

export default TimesheetDetail;
